import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=c41517fc&scoped=true&"
import script from "./ChangePassword.vue?vue&type=script&lang=ts&"
export * from "./ChangePassword.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.scss?vue&type=style&index=0&id=c41517fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41517fc",
  null
  
)

export default component.exports